(function() {
    var toSex = function(code) {
        var sex;
        switch (code) {
            case 0:
                sex = "男";
                break;
            case 1:
                sex = "女";
                break;
        }
        return sex;
    }
    window.toSex = toSex;

    const toDate = function(date, type) {
        let d = new Date(date);
        let result = d.getFullYear().toString() + "-";
        result = result + ((d.getMonth() + 1) < 10 ? "0" + (d.getMonth() + 1) : (d.getMonth() + 1).toString()) + "-";
        result = result + (d.getDate() < 10 ? "0" + d.getDate() : d.getDate().toString()); //2011
        if (type.split(" ").length == 2) {
            result = result + " " + (d.getHours().toString() < 10 ? "0" + d.getHours() : d.getHours().toString()) + ":";
            result = result + (d.getMinutes().toString() < 10 ? "0" + d.getMinutes() : d.getMinutes().toString()) + ":";
            result = result + (d.getSeconds().toString() < 10 ? "0" + d.getSeconds() : d.getSeconds().toString());

        }
        return result;
    }
    window.toDate = toDate;

    Date.prototype.Format = function(fmt) {
    var o = {
        "M+": this.getMonth() + 1, // 月份
        "d+": this.getDate(), // 日
        "h+": this.getHours(), // 小时
        "m+": this.getMinutes(), // 分
        "s+": this.getSeconds(), // 秒
        "q+": Math.floor((this.getMonth() + 3) / 3), // 季度
        "S": this.getMilliseconds()
            // 毫秒
    };
    if (/(y+)/.test(fmt))
        fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "")
            .substr(4 - RegExp.$1.length));
    for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt))
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
}


})()

//md5加密 账号，密码
export const MD5 = function(arg1,arg2) {
    return md5(md5(arg1) + md5(arg2))
}

//创建订单
export const createOrder = function(info,isJump) {
    this.orderAxios.post('/create', info)
        .then(response => {
            if (response.data.code == '200') {
                if(isJump == 'false'){
                    this.$alert('请联系管理员改价后完成订单支付', '订单已生成', {
                        confirmButtonText: '确定',
                        callback: action => {
                            this.$router.push('/cost/order')
                        }
                    });
                }else{
                    this.$router.push({ name: 'Prepay', params: { orderId: response.data.data.orderNo } })
                }
            }
        })
}

//创建过程
export const createNotify = (_this) => {
    _this.$WebSocket.onmessage = evt => {
        _this.$store.commit('updateCreateStatus', JSON.parse(evt.data))
        let show = _this.$store.state.createNotifyShow
        let items = _this.$store.state.create.items
        let current = 0
        for(let i in items){
            if(items[i].itemStatus=='WaitCreate' && show==false){
                _this.$store.commit('updateCreateNotifyShow', true)
                setTimeout(() => {
                    _this.$store.commit('updateCreateNotifyShow', false)
                },120000)
            }
            if(items[i].itemStatus=='Created'){
                current++
            }
            if(current==items.length){
                _this.$store.commit('updateCreateNotifyShow', false)
                _this.notify.success('创建成功',() => {
                    _this.$store.commit('updateRefresh')
                })
            }
        }
        _this.$store.commit('updateCreateCurrentStatus', current)
    }
}

//获取url参数
export const GetQueryString = function(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return unescape(r[2]);
    return null;
}

//可用区名字转换
export const getZoneName = function(zoneId) {
    if (!zoneId) {
        return
    }
    var zoneArr = zoneId.split("-");
    var zoneStr = "";
    if (zoneArr[2].search("MAZ1") == -1) {
        switch (zoneArr[1]) {
            case 'beijing':
                zoneStr += '华北2';
                break;
            case 'qingdao':
                zoneStr += '华北1';
                break;
            case 'hangzhou':
                zoneStr += '华东1';
                break;
            case 'shanghai':
                zoneStr += '华东2';
                break;
            case 'shenzhen':
                zoneStr += '华南1';
                break;
            case 'hongkong':
                zoneStr += '香港';
                break;
            case 'zhangjiakou':
                zoneStr += '华北3';
                break;
            case 'huhehaote':
                zoneStr += '华北5';
                break;
        }
        zoneStr += ' 可用区'
        zoneStr += zoneArr[2].toUpperCase();
    } else {
        var zoneMAZ1 = zoneArr[2].substring(5, 8);
        var zoneMAZ1Arr = zoneMAZ1.split(',');
        zoneStr = '多可用区（可用区' + zoneMAZ1Arr[0].toUpperCase() + '+可用区' + zoneMAZ1Arr[1].toUpperCase() + '）'
    }
    return zoneStr;
}

//地域名字转换
export const getRegionName = function(regionId) {
    switch (regionId) {
        case 'cn-hangzhou':
            regionId = '华东1'
            break;
        case 'cn-shanghai':
            regionId = '华东2'
            break;
        case 'cn-qingdao':
            regionId = '华北1'
            break;
        case 'cn-beijing':
            regionId = '华北2'
            break;
        case 'cn-zhangjiakou':
            regionId = '华北3'
            break;
        case 'cn-huhehaote':
            regionId = '华北5'
            break;
        case 'cn-shenzhen':
            regionId = '华南1'
            break;
        case 'cn-hongkong':
            regionId = '香港'
            break;
    }
    return regionId
}

//商品名称
export const getGoodsName = function(goodsName) {
    switch (goodsName) {
        case 'Z_VM':
            goodsName = '云主机'
            break;
        case 'Z_EIP':
            goodsName = '弹性IP'
            break;
        case 'Z_DISK':
            goodsName = '云盘'
            break;
        case 'Z_SLB':
            goodsName = '负载均衡'
            break;
        case 'Z_PORT':
            goodsName = '端口转发'
            break;
        case 'RECS':
            goodsName = 'ECS续费'
            break;
        case 'RRDS':
            goodsName = 'RDS续费'
            break;
        case 'RSLB':
            goodsName = 'SLB续费'
            break;
        case 'REIP':
            goodsName = 'EIP续费'
            break;
    }
    return goodsName
}

//网络类型名字转换
export const getNetWorkName = function(network) {
    network = network != undefined && network.toLowerCase()
    switch (network) {
        case 'classic':
            network = '经典网络'
            break;
        case 'vpc':
            network = '专有网络'
            break;
    }
    return network
}

//磁盘类型名称转换
export const getDiskName = function(type) {
    type = type != undefined && type.toLowerCase()
    switch (type) {
        case 'cloud':
            type = '普通云盘'
            break;
        case 'cloud_ssd':
            type = 'SSD云盘'
            break;
        case 'cloud_efficiency':
            type = '高效云盘'
            break;
    }
    return type
}

//时间格式转换
export const toDate = function(date, type) {
    if(!date){
        return
    }
    if(isNaN(date)){
        date = date.replace('Z','').replace(/\-/g,'/').replace('T',' ')
    }
    let d = new Date(date);
    let result = d.getFullYear().toString() + "-";
    result = result + ((d.getMonth() + 1) < 10 ? "0" + (d.getMonth() + 1) : (d.getMonth() + 1).toString()) + "-";
    result = result + (d.getDate() < 10 ? "0" + d.getDate() : d.getDate().toString()); //2011
    if (type.split(" ").length == 2) {
        result = result + " " + (d.getHours().toString() < 10 ? "0" + d.getHours() : d.getHours().toString()) + ":";
        result = result + (d.getMinutes().toString() < 10 ? "0" + d.getMinutes() : d.getMinutes().toString()) + ":";
        result = result + (d.getSeconds().toString() < 10 ? "0" + d.getSeconds() : d.getSeconds().toString());

    }
    return result;
}

//状态转换
export const getStatus = function(status) {
    status = status != undefined && status.toLowerCase()
    switch (status) {
        case 'running':
            status = '运行中'
            break;
        case 'starting':
            status = '启动中'
            break;
        case 'creating':
        case 'pending':
            status = '创建中'
            break;
        case 'stopping':
            status = '停止中'
            break;
        case 'stopped':
            status = '已停止'
            break;
        case 'in_use':
            status = '使用中'
            break
        case 'available':
            status = '可用'
            break
        case 'attaching':
            status = '挂载中'
            break
        case 'unavailable':
            status = '不可用'
            break
        case 'linkswitching':
            status = '链路切换中'
            break
        case 'net_modifying':
            status = '修改网络连接中'
            break;
        case 'dbinstancenettypechaning':
            status = '申请内网地址中'
            break;
        case 'net_creating':
            status = '创建网络连接中'
            break;
        case 'net_deleting':
            status = '释放网络连接中'
            break;
        case 'deleting':
            status = '删除中'
            break;
        case 'restoring':
            status = '恢复中'
            break;

    }
    return status
}

//运行状态颜色
export const getStatusClass = function(status) {
    status = status != undefined && status.toLowerCase()
    switch (status) {
        case 'running':
            status = 'text-success'
            break;
        case 'starting':
            status = 'text-success'
            break;
        case 'creating':
        case 'pending':
            status = 'text-warning'
            break;
        case 'stopped':
            status = 'text-danger'
            break;
        case 'stopping':
            status = 'text-danger'
            break;
        case 'in_use':
            status = 'text-success'
            break
        case 'attaching':
            status = 'text-success'
            break
        case 'available':
            status = 'text-success'
            break;
        case 'unavailable':
            status = 'text-danger'
            break;
        case 'deleting':
            status = 'text-danger'
            break;
        case 'LinkSwitching':
            status = 'text-danger'
            break;
        case 'NET_MODIFYING':
            status = 'text-danger'
            break;
        case 'DBInstanceNetTypeChanging':
            status = 'text-danger'
            break;
        case 'NET_CREATING':
            status = 'text-danger'
            break;
        case 'NET_DELETING':
            status = 'text-danger'
            break;
        case 'Restoring':
            status = 'text-danger'
            break;
    }
    return status
}

//ZStack状态转换
export const getZStackStatus = function(status) {
    status = status != undefined && status.toLowerCase()
    switch (status) {
        case 'running':
            status = '运行中'
            break;
        case 'starting':
            status = '启动中'
            break;
        case 'creating':
        case 'pending':
            status = '创建中'
            break;
        case 'stopping':
            status = '停止中'
            break;
        case 'stopped':
            status = '已停止'
            break;
        case 'in_use':
            status = '使用中'
            break
        case 'available':
            status = '可用'
            break
        case 'enabled':
            status = '启用'
            break
        case 'ready':
            status = '就绪'
            break
        case 'disabled':
            status = '停用'
            break
        case 'attaching':
            status = '挂载中'
            break
        case 'unavailable':
            status = '不可用'
            break
        case 'deleting':
            status = '删除中'
            break;
        case 'restoring':
            status = '恢复中'
            break;
        case 'notinstantiated':
            status = '未实例化'
            break;
        case 'paused':
            status = '暂停中'
            break;
    }
    return status
}

//ZStack运行状态颜色
export const getZStackStatusClass = function(status) {
    status = status != undefined && status.toLowerCase()
    switch (status) {
        case 'running':
            status = 'text-success'
            break;
        case 'starting':
            status = 'text-success'
            break;
        case 'creating':
        case 'pending':
        case 'notinstantiated':
        case 'paused':
            status = 'text-warning'
            break;
        case 'stopped':
            status = 'text-danger'
            break;
        case 'stopping':
            status = 'text-danger'
            break;
        case 'in_use':
            status = 'text-success'
            break
        case 'attaching':
            status = 'text-success'
            break
        case 'available':
        case 'enabled':
        case 'ready':
            status = 'text-success'
            break;
        case 'unavailable':
        case 'disabled':
            status = 'text-danger'
            break;
        case 'deleting':
            status = 'text-danger'
            break;
        case 'LinkSwitching':
            status = 'text-danger'
            break;
        case 'NET_MODIFYING':
            status = 'text-danger'
            break;
        case 'DBInstanceNetTypeChanging':
            status = 'text-danger'
            break;
        case 'NET_CREATING':
            status = 'text-danger'
            break;
        case 'NET_DELETING':
            status = 'text-danger'
            break;
        case 'Restoring':
            status = 'text-danger'
            break;
    }
    return status
}

//云盘状态转换
export const getDiskStatus = function(status) {
    switch (status) {
        case 'Creating':
            status = '创建中'
            break;
        case 'In_use':
            status = '使用中'
            break
        case 'Available':
            status = '待挂载'
            break
        case 'Attaching':
            status = '挂载中'
            break
        case 'Detaching':
            status = '卸载中'
            break
        case 'ReIniting':
            status = '初始化中'
            break
        case 'Deleting':
            status = '删除中'
            break;
        case 'Deleted':
            status = '已删除'
            break;
    }
    return status
}

//云盘运行状态颜色
export const getDiskStatusClass = function(status) {
    switch (status) {
        case 'Creating':
            status = 'text-warning'
            break;
        case 'In_use':
            status = 'text-success'
            break
        case 'Attaching':
            status = 'text-success'
            break
        case 'Available':
            status = 'text-success'
            break;
        case 'Detaching':
            status = 'text-danger'
            break;
        case 'Deleting':
            status = 'text-danger'
            break;
        case 'Deleted':
            status = 'text-danger'
            break;
        case 'ReIniting':
            status = 'text-success'
            break;
    }
    return status
}

//快照状态转换
export const getSnapshotStatus = function(status) {
    switch (status) {
        case 'progressing':
            status = '正在创建'
            break;
        case 'accomplished':
            status = '创建成功'
            break;
        case 'failed':
            status = '创建失败'
            break;
    }
    return status
}

//快照运行状态颜色
export const getSnapshotStatusClass = function(status) {
    switch (status) {
        case 'progressing':
            status = 'text-warning'
            break;
        case 'accomplished':
            status = 'text-success'
            break;
        case 'failed':
            status = 'text-danger'
            break;
    }
    return status
}

//EIP状态转换
export const getEIPStatus = function(status) {
    switch (status) {
        case 'Associating':
            status = '绑定中'
            break;
        case 'Unassociating':
            status = '解绑中'
            break;
        case 'InUse':
            status = '已分配'
            break;
        case 'Available':
            status = '可用'
            break;
    }
    return status
}

//EIP运行状态颜色
export const getEIPStatusClass = function(status) {
    switch (status) {
        case 'Associating':
            status = 'text-warning'
            break;
        case 'Unassociating':
            status = 'text-warning'
            break;
        case 'InUse':
            status = 'text-danger'
            break;
        case 'Available':
            status = 'text-success'
            break;
    }
    return status
}

//SLB状态转换
export const getSLBStatus = function(status) {
    switch (status) {
        case 'inactive':
            status = '已停止'
            break;
        case 'active':
            status = '运行中'
            break;
        case 'locked':
            status = '不可用'
            break;
    }
    return status
}

//SLB运行状态颜色
export const getSLBStatusClass = function(status) {
    switch (status) {
        case 'inactive':
            status = 'text-danger'
            break;
        case 'active':
            status = 'text-success'
            break;
        case 'locked':
            status = 'text-danger'
            break;
    }
    return status
}


//报警规则状态转换
export const getAlarmStatus = function(status) {
    switch (status) {
        case 'INSUFFICIENT_DATA':
            status = '数据不足'
            break;
        case 'OK':
            status = '正常状态'
            break;
        case 'ALARM':
            status = '报警中'
            break;
    }
    return status
}

//报警规则运行状态颜色
export const getAlarmStatusClass = function(status) {
    switch (status) {
        case 'INSUFFICIENT_DATA':
            status = 'text-warning'
            break;
        case 'OK':
            status = 'text-success'
            break;
         case 'ALARM':
            status = 'text-danger'
            break;
    }
    return status
}

// //工单状态
// export const getWorkOrderState = function(status) {
//     switch (status) {
//         case 'inactive':
//             status = 'text-danger'
//             break;
//         case 'active':
//             status = 'text-success'
//             break;
//         case 'locked':
//             status = 'text-danger'
//             break;
//     }
//     return status
// }

//RDS实例类型
export const getRDSInstanceType = function(type) {
    type = type != undefined && type.toLowerCase()
    switch (type) {
        case 'primary':
            type = '常规实例'
            break;
    }
    return type
}
//付费类型
export const getPayType = function(type) {
    type = type != undefined && type.toLowerCase()
    switch (type) {
        case 'postpaid':
        case 'postpay':
            type = '按量付费'
            break;
        case 'prepaid':
            type = '包年包月'
            break;
    }
    return type
}


//RDS访问模式
export const getRDSConnectionMode = function(type) {
    switch (type) {
        case 'Standard':
            return '标准模式';
        case 'Safe':
            return '高安全模式';
    }
    return type;
}

//星期转换
export const getWeek = function(day) {
    switch (day) {
        case 'Monday':
            return '星期一';
        case 'Tuesday':
            return '星期二';
        case 'Wednesday':
            return '星期三';
        case 'Thursday':
            return '星期四';
        case 'Friday':
            return '星期五';
        case 'Saturday':
            return '星期六';
        case 'Sunday':
            return '星期日';
    }
    return day;
}

//工单分类
export const getWorkOrderType = function(type) {
    switch (type) {
        case 'PROBLEM_ECS':
            return '云服务器ECS';
        case 'PROBLEM_RDS':
            return '云数据库RDS';
        case 'PROBLEM_SLB':
            return '负载均衡SLB';
        case 'PROBLEM_VPC':
            return '专有网络VPC';
        case 'PROBLEM_EIP':
            return '弹性公网IP';
        case 'PROBLEM_FINANCE':
            return '财务';
        case 'PROBLEM_ACCOUNT':
            return '会员账号类';
    }
    return type;
}

//三层网络类型
export const getNetworkType = function(type) {
    type = type != undefined && type.toLowerCase()
    switch (type) {
        case 'private':
            type =  '私有网络';
            break;
        case 'public':
            type =  '公有网络';
            break;
        case 'router':
            type =  '云路由';
            break;
    }
    return type;
}

//容量转换
export const memorySizeChange = function(size) {
    if(isNaN(size)){
        return
    }
    if(size>=1099511627776){
        return parseInt(size/1099511627776)+'TB'
    }else if(size>=1073741824){
        return parseInt(size/1073741824)+'GB'
    }else if(size>=1048576){
        return parseInt(size/1048576)+'MB'
    }else if(size>=1024){
        return parseInt(size/1024)+'KB'
    }else{
        return
    }
}

 //TODO 相减操作,保证精度
export const sub= function(arg1, arg2) {
    var r1, r2, m, n;
    try {
        r1 = arg1.toString().split(".")[1].length
    } catch (e) {
        r1 = 0
    }
    try {
        r2 = arg2.toString().split(".")[1].length
    } catch (e) {
        r2 = 0
    }
    m = Math.pow(10, Math.max(r1, r2));
    n = (r1 >= r2) ? r1 : r2;
    return ((arg1 * m - arg2 * m) / m).toFixed(n);
}

//判断是否为一个正确的CIDR地址格式：192.168.0.1/24
export const  isMaskNet=function(netStr){
    if(netStr==undefined||netStr==null){
        return false;
    }
    //提取出网段和掩码
    var netStrArr=netStr.split('/');
    if (netStrArr.length!=2) {
        return false;
    }
    var mask=netStrArr[1];//掩码
    if (isNaN(mask)||mask<0||mask>32) {
        return false;
    }
    var netArr=netStrArr[0].split('.');//网段地址数组
    if (netArr.length!=4) {
        return false;
    }
    for (var i = 0; i < netArr.length; i++) {
        if (isNaN(netArr[i])||netArr[i]<0||netArr[i]>255) {
            return false;
        }
        //判断子网掩码是否正确
        if ((getIntByMaskAndIndex(mask,i)&netArr[i])!=netArr[i]) {
            return false;
        }
    }

    return true;
}

//根据掩码和第几个的位置获取当前位置的掩码值
function getIntByMaskAndIndex(mask,index){
    var maskInt;
    if (mask-index*8>=8) {
        maskInt= 8;
    }else if(mask-index*8<=0){
        maskInt= 0;
    }else{
        maskInt= mask-index*8;
    }

    return Math.pow(2,8)-1-(Math.pow(2,8-maskInt)-1);
}

//获取某个网段可用的IP个数
export const  getUsableIP = function(mask){
    if(isMaskNet(mask)){
        var netStrArr=mask.split('/');
        if (netStrArr.length==2&&!isNaN(netStrArr[1])) {
            return Math.pow(2,32-netStrArr[1])-4;
        }else{
            return 0;
        }
    }else{
        return 0;
    }
}

//查询报警规则
export const getAlarmRule = (row,describeList)=> {
    let period = row.period/60 +'分钟'
    let describe = ''
    let statistics = ''
    let comparisonOperator = row.comparisonOperator
    let threshold = row.threshold
    let evaluationCount = row.evaluationCount
    for(let i in describeList){
        if(row.metricName == describeList[i].itemCode){
            describe = describeList[i].itemName
        }
    }
    if(row.statistics == 'Average'){
        statistics = '平均值'
    }else if(row.statistics == 'Minimum'){
        statistics = '总是'
    }else{
        statistics = '只要有一次'
    }
    return  period + describe + statistics + comparisonOperator + threshold + '连续' + evaluationCount +'次 则报警'
}

//echarts折线图
export const echartsLine = (options,myChart) => {
    let series = []
    for(let i in options.name){
        series.push({
            name: options.name[i],
            type: options.series.type[i],
            showSymbol: options.series.showSymbol[i],
            hoverAnimation: options.series.hoverAnimation[i],
            areaStyle:options.series.areaStyle[i]?{normal: {}}:null,
            stack:options.series.stack[i],
            data: options.series.data[i]
        })
    }
    let option = {}
    if(options.series.data[0].length<=0){
        option={
            title: {
                text: '暂无数据',
                top:'45%',
                left:'40%'
            },
        }
    }else{
        option = {
        tooltip: {
            trigger: 'axis',
            formatter: options.tooltip.formatter,
            axisPointer: {
                animation: false
            }
        },
        toolbox: {
            feature: {
                dataZoom: {
                    yAxisIndex: 'none'
                },
                restore: {},
                saveAsImage: {}
            }
        },
        legend: {
            bottom: '0',
            data: options.name
        },
        grid: {
            top: '30',
            left: '3%',
            right: '4%',
            bottom: '25',
            containLabel: true
        },
        xAxis: {
            type: options.xAxis.type,
            splitLine: {
                show: true
            },
        },
        yAxis: {
            type: options.yAxis.type,
            axisLabel: {
                formatter: options.yAxis.axisLabel.formatter
            },
            min:options.yAxis.min,
            max:options.yAxis.max,
            splitLine: {
                show: true
            }
        },
        series: series
    };
    }
    
    myChart.setOption(option)
}

//echartstooltip 
//时间：
//name：val%
export const  echartsTooltipPercen = (params) => {
    let date = new Date(params[0].name)
    let str = date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear() +'<br>'
    for(let i in params){
        let param = params[i]
        str +=  param.seriesName +'：'  + parseInt(param.value[1]).toFixed(2)+'%' +'<br>'
    }
    return str
}

//echartsyAxisaxisLabel
//格式：val%
export const  yAxisFormatterPercen = function (val) {
    return val + '%';
}

//echartstooltip 
//时间：
//name：valK
export const  echartsTooltipK = (params) => {
    let date = new Date(params[0].name)
    let str = date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear() +'<br>'
    for(let i in params){
        let param = params[i]
        let val 
        if(param.value[1]>=1024*1024*1024){
            val = (param.value[1]/(1024*1024*1024)).toFixed(2) + 'G'
        }else if(param.value[1]>=1024*1024){
            val = (param.value[1]/(1024*1024)).toFixed(2) + 'M'
        }else if(param.value[1]>=1024){
            val = (param.value[1]/(1024)).toFixed(2) + 'K'
        }else if(param.value[1] == 0){
            val = param.value[1]
        }else{
            val =parseInt(param.value[1]).toFixed(2)
        }
        str +=  param.seriesName +'：'  + val +'<br>'
    }
    return str
}

//echartsyAxisaxisLabel
//格式：val%
export const  yAxisFormatterK = function (val) {
    if(val>=1024*1024*1024){
        return (val/(1024*1024*1024)).toFixed(2) + 'G'
    }else if(val>=1024*1024){
        return (val/(1024*1024)).toFixed(2) + 'M'
    }else if(val>=1024){
        return (val/(1024)).toFixed(2) + 'K'
    }else{
        return val 
    }
}

//echartstooltip 
//时间：
//name：P/S
export const  echartsTooltipPS = (params) => {
    let date = new Date(params[0].name)
    let str = date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear() +'<br>'
    for(let i in params){
        let param = params[i]
        let val =parseInt(param.value[1]).toFixed(2) + 'P/S'
        str +=  param.seriesName +'：'  + val +'<br>'
    }
    return str
}

//echartsyAxisaxisLabel
//格式：valP/S
export const  yAxisFormatterPS = function (val) {
    return parseInt(val).toFixed(2) + 'P/S'
}

//echartstooltip 
//时间：
//name：val个
export const  echartsTooltipCount = (params) => {
    let date = new Date(params[0].name)
    let str = date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear() +'<br>'
    for(let i in params){
        let param = params[i]
        str +=  param.seriesName +'：'  + parseInt(param.value[1])+'个' +'<br>'
    }
    return str
}

//echartsyAxisaxisLabel
//格式：val个
export const  yAxisFormatterCount = function (val) {
    return val + '个';
}

//echartstooltip 
//时间：
//name：val次/秒
export const  echartsTooltipFrequencySecond = (params) => {
    let date = new Date(params[0].name)
    let str = date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear() +'<br>'
    for(let i in params){
        let param = params[i]
        str +=  param.seriesName +'：'  + parseInt(param.value[1])+'个/秒' +'<br>'
    }
    return str
}

//echartsyAxisaxisLabel
//格式：val次/秒
export const  yAxisFormatterFrequencySecond = function (val) {
    return val + '个/秒';
}


// WEBPACK FOOTER //
// ./src/utils/common.js